import { css } from '@emotion/css';

//!important required to override the styles of pasted content
export const calloutContainerStyles = (textColor?: string) => css`
  * {
    font-weight: var(--medium) !important;
    color: ${textColor || 'var(--text-white)'}!important;
  }

  &.callout--placeholder::before {
    color: ${textColor || 'var(--text-white)'}!important;
    opacity: 0.6;
    font-size: 1.8rem;
    line-height: 2.7rem;
    padding-inline-start: 5.6rem;
    position: absolute;
    margin-top: 4rem;
  }

  &.calloutContainer {
    @media (min-width: 767px) {
      margin-inline-start: -5.6rem;
      margin-inline-end: -5.6rem;
    }

    p {
      padding-inline-start: 5.6rem;
      padding-inline-end: 5.6rem;
    }
  }
`;

export const calloutTextStyles = css`
  * {
    background: transparent !important;
  }
`;
